import { ConfirmationStage, SelectPartitionStage, SelectProductAndQuantityStage } from "./stages";
import { FC, useCallback, useState } from "react";
import Wizard, { WizardStep } from "features/common/Wizard";

import { IntroStage } from "features/common/stages";
import { createAdjustment } from "domains/allocations/services/allocation-service";
import localisations from "../../localisation";

type AdjustmentAllocationFeatureProps = {
    fieldCompanyId: number;
};

const AdjustmentAllocationFeature: FC<AdjustmentAllocationFeatureProps> = ({fieldCompanyId}) => {
    const { intro, selectPartition, selectProductAndQuantity, confirmation } = localisations.adjustmentAllocation.stepper;
    const [fields, setFields] = useState({} as any);
    const [productStatus, setProductStatus] = useState(false);
    const [productQuantityStatus, setProductQuantityStatus] = useState(false);

    const handleFieldChange = useCallback((newFields: any) => setFields((x:any) => ({ ...x, ...newFields })), [setFields]);
    const handleAdjustProductStatus = useCallback((status: boolean) => setProductStatus(status), [setProductStatus]);
    const handleProductQuantityStatus = useCallback((status: boolean) => setProductQuantityStatus(status), [setProductQuantityStatus]);

    let childProps = {
        fieldCompanyId,
        fields,
        handleFieldChange,
        handleAdjustProductStatus,
        handleProductQuantityStatus
    }

    let steps = [
        {
            label: intro,
            component: <IntroStage localisations={localisations.adjustmentAllocation.stages.intro}/>
        },
        {
            label: selectPartition,
            component: <SelectPartitionStage {...childProps} />,
            disableNextButton:() => fields.partitionDetails?.id == null
        },
        {
            label: selectProductAndQuantity,
            component: <SelectProductAndQuantityStage {...childProps} />,
            disableNextButton:() => !productStatus || !productQuantityStatus || fields.notes === undefined || fields.notes === null || fields.notes?.trim() === ''
        },
        {
            label: confirmation,
            component: <ConfirmationStage {...childProps}/>,
            onNext: async ():Promise<boolean> => {
                await createAdjustment({
                    fieldCompanyId: fieldCompanyId,
                    partitionId: fields.partitionDetails?.id,
                    productId: fields.productDetails?.id,
                    quantityChange: fields.quantityChange,
                    notes: fields.notes,
                });
                return true;
            }
        }
    ] as WizardStep[];

    return (
        <Wizard
            fieldCompanyId={fieldCompanyId}
            steps={steps}
            resultStageLocalisations={localisations.adjustmentAllocation.stages.result}
            serverErrorLocalisations={localisations.adjustmentAllocation.serverErrors}
        />
    );
}

export default AdjustmentAllocationFeature;